import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addHolidaySchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.holidayName)),
    date: Yup.string().required(Strings.validation.fieldRequired(Strings.field.holidayDate)),
    image: Yup.string().required(Strings.validation.uploadRequired(Strings.field.holidayImage)),
  })
  .required();
